// EA crosses use a debit and must not enter the supplier-advance removal path.
export const isSupplierAdvance = (entry) => Boolean(entry?.supplier_advance_id || (
  Number(entry?.credit) > 0 && entry?.advance_invc && entry?.advance_cruce
));

export async function removeSupplierAdvance(supabase, userId, invoiceId, entryId) {
  const { error } = await supabase.rpc('invoice_remove_supplier_advance', {
    p_user_id: userId, p_invoice_id: invoiceId, p_entry_id: entryId
  });
  if (error) throw error;
}
